import { useQuery } from "@tanstack/react-query";

import { userKeys } from "../queryKeys";
import { searchUsers } from "../services/search.service";
import { searchUsersParams } from "../types/search.types";
import { formatSearchUsersFormatter } from "../formatters/formatSearchUsersFormatter";

export const useSearchUsers = (params: searchUsersParams) => {
  const searchParams = formatSearchUsersFormatter(params);
  return useQuery({
    queryKey: userKeys.search(searchParams),
    queryFn: () => searchUsers(searchParams),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
